module.exports = __webpack_public_path__ + "static/img/LUCCA-GREGO.b416cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCCA-GREGO.jpg
// module id = k3qQ
// module chunks = 0